import React ,{Component} from 'react';
import { NavLink,Navigate  } from 'react-router-dom';
 import { styled } from '@mui/system';
import { Redirect  } from 'react-router-dom';
import Button from '@mui/material/Button';
import axios from 'axios';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import PersonIcon from '@mui/icons-material/Person';
import Paper from '@mui/material/Paper';  
import Table from '@mui/material/Table'; 
import TableContainer from '@mui/material/TableContainer';  
import TableRow from '@mui/material/TableRow';  
import TableHead from '@mui/material/TableHead';  
import TableCell from '@mui/material/TableCell'; 
import TableSortLabel from '@mui/material/TableSortLabel'; 
import PropTypes from 'prop-types';
import TablePagination from '@mui/material/TablePagination';  
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import TableBody from '@mui/material/TableBody';
import TextField from '@mui/material/TextField';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import Addsalestax from './Addsalestax';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import smallrightimage from './images/smallright.png';


function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}


function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}


const headCells = [

{ id: '', numeric: false,  label: ' ' },
{ id: 'tx_name', numeric: false,  label: ' Name' },
{ id: 'dwt_percentage', numeric: false,  label: ' Percentage' },
{ id: 'dwt_percentage', numeric: false,  label: ' Agency' },
{ id: '', numeric: false,  label: ' Combined?' },
{ id: '', numeric: false,  label: ' Visible?' },

]

function EnhancedTableHead(props) {
  const {  order, orderBy,   onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };
  
  
return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = styled(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));


const EnhancedTableToolbar = props => {
const classes = useToolbarStyles();
const { numSelected } = props;

  
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = styled(theme =>({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 

  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
 
form: {
    width: '500%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
	 minWidth: 120,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  
   textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  
})
)


export default class SalesTax extends Component {
	constructor(props) {
    super();
this.state = {
logredirect:false,pagename:'',page: 0 ,prevpage:0,totaldata:0,rowsPerPage:20,rowsPaging:[],
	 search:'',id:'',order:'desc' ,orderBy:'tx_id',
	btndisabled:false,
submitbtn:"Submit",  TaxData:[],txid:'',
      }
	  
	 };
	
  myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val});

 }



componentWillMount() {
	
		document.title = "Isifol - Sales Tax";
	 if(localStorage.getItem("ISIuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
else
{	
if(localStorage.getItem("ISIrole")==="1" || localStorage.getItem("ISIrole")==="2")
		  {
			 this.GetTaxData();   
		  }
		  else{
	    
		this.PageAccessCheckApi();
		  }
	}	  
	    
		 this.props.parentdasCallback(
            "Sales Tax Rates~"
        );

	}
	
	PageAccessCheckApi() {
	
  axios.get(localStorage.getItem("ISIurl")+'ajaxpagemaster.php?action=getbyuser&us_id='+localStorage.getItem('ISIuserid')+'&up_pm_id=24')
  
  .then(resp => {
	  
	  
	  let strreturn=resp.data;

      if (strreturn!==0) {
        	
	 this.GetTaxData();   
      } else {
       
        this.setState({redirect: true,pagename: "/Accesspagemessage"});
      }
    
  });
}
	
	
	 	GetTaxData(){
 
 
  axios.get(localStorage.getItem("ISIurl")+'ajaxtax.php?action=lists&tx_cmp_id='+localStorage.getItem("ISIcmpid"))
  .then(resp => {  
		
    
		
			this.setState({  
			  TaxData: resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			   
			});
    
	
   
    });

}



  
   deleteTax(txid){  
  
		let r = window.confirm("Do you really want to Delete?");
		 if(r == true){ //sign Out logic
				 var formData = new FormData(); 
					 formData.append('action','delete')					 
					 formData.append('tx_id',txid)
					 formData.append('userid',localStorage.getItem("ISIuserid"))
					 formData.append('tx_cmp_id',localStorage.getItem("ISIcmpid"))
					
					axios.post(localStorage.getItem("ISIurl")+"ajaxtax.php", formData, {
						}).then(res => {
					
					 this.GetTaxData(); 
					
							});
		 }
 }
 
   

 

    SalesAddBox(val,val2,va3){
        this.setState({ txid: val,txmainid:val2,ismultple: va3});  
  
         setTimeout(() => this.refs.Addsalestax.handleClickOpen(),500);

      }

 
render() {
  if (this.state.redirect === true) {
    return <Navigate to={this.state.pagename} />;
  }

  return (
    <React.Fragment>
     

<p id="tax-settings-info"><i class="icon-info"></i>Sales tax depends on your customer's location and create them below.</p>
<p className="alignright">
<Button
  type="submit"
  variant="contained"
  className="frmSecondarybtn"
  onClick={() => this.SalesAddBox(0)} 
>
 
  New Tax Rate
</Button>

</p>




  
    
      <Addsalestax ref="Addsalestax" txid={this.state.txid} txmainid={this.state.txmainid} ismultple={this.state.ismultple} />

      <Paper className={useStyles.root}>
        <TableContainer className={useStyles.container}>
          <Table stickyHeader aria-label="sticky table">
            <EnhancedTableHead
              order={this.state.order}
              orderBy={this.state.orderBy}
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.TaxData.length}
            />
            <TableBody>
              {this.state.TaxData.map((item, index) => {
                
                  return (
                    <TableRow key={index}>
					<TableCell onClick={() => { this.deleteTax(item.tx_id) }}>  <DeleteIcon /></TableCell>
					
                      <TableCell>{item.tx_name}</TableCell>
                      <TableCell >{item.dwt_percentage}</TableCell>
                      <TableCell  onClick={() => { this.SalesAddBox(item.tx_id,item.tx_mainid,item.tx_agency) }}>{item.tx_agency}</TableCell>
					
					 
					 {item.tx_mainid!=="0" && (
                      <TableCell></TableCell>
					 )}
					 {item.tx_mainid==="0" && (
                      <TableCell onClick={() => { this.SalesAddBox(item.tx_id,item.tx_mainid,item.tx_agency) }}><img src={smallrightimage} /></TableCell>
					 )}
					  
					
					  {item.tx_mainid!=="0" && (
                      <TableCell onClick={() => { this.SalesAddBox(item.tx_id,item.tx_mainid,item.tx_agency) }}></TableCell>
                       )}
					   
                  {item.tx_mainid==="0" && (
                      <TableCell onClick={() => { this.SalesAddBox(item.tx_id,item.tx_mainid,item.tx_agency) }}><img src={smallrightimage} /></TableCell>
					 )}
                    </TableRow>
                  );
              
              })}
            </TableBody>
          </Table>
        </TableContainer>
       
      </Paper>
    </React.Fragment>
  );
}
   
}